// ===============================
// OngletAccueil.jsx
// ===============================
// Page d'accueil du planning
// - Deux entrées principales :
//    • Interface Responsable
//    • Interface Médecin
// ===============================

import React from "react";
import { useNavigate } from "react-router-dom";

export default function OngletAccueil() {
  const navigate = useNavigate();

  const S = {
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background:
        "linear-gradient(135deg, #eef2ff 0%, #f9fafb 40%, #ecfeff 100%)",
      fontFamily:
        "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      padding: "24px",
    },
    card: {
      maxWidth: "900px",
      width: "100%",
      background: "#ffffff",
      borderRadius: "24px",
      padding: "32px 32px 28px",
      boxShadow: "0 18px 45px rgba(15,23,42,0.18)",
      border: "1px solid #e5e7eb",
    },
    title: {
      fontSize: "32px",
      fontWeight: 800,
      marginBottom: "4px",
      color: "#111827",
    },
    subtitle: {
      fontSize: "18px",
      color: "#4b5563",
      marginBottom: "24px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "24px",
      marginTop: "12px",
    },
    btn: {
      padding: "28px 22px",
      borderRadius: "18px",
      border: "1px solid #111827",
      background: "#111827",
      color: "#ffffff",
      cursor: "pointer",
      fontSize: "20px",
      fontWeight: 800,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      boxShadow: "0 10px 30px rgba(15,23,42,0.35)",
      transition: "transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease",
    },
    btnLight: {
      background: "#ffffff",
      color: "#111827",
      border: "1px solid #d1d5db",
      boxShadow: "0 8px 22px rgba(148,163,184,0.35)",
    },
    btnTitle: {
      fontSize: "22px",
      fontWeight: 800,
    },
    btnDesc: {
      fontSize: "15px",
      fontWeight: 500,
      color: "inherit",
      opacity: 0.9,
    },
    footer: {
      marginTop: "22px",
      fontSize: "13px",
      color: "#6b7280",
    },
  };

  return (
    <div style={S.container}>
      <div style={S.card}>
        <h1 style={S.title}>Planning Anesthésie – Port Royal</h1>
        <p style={S.subtitle}>
          Choisissez votre interface pour accéder au planning, aux gardes et aux
          desiderata.
        </p>

        <div style={S.grid}>
          {/* Interface Responsable */}
          <button
            style={S.btn}
            onClick={() => navigate("/responsable")}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 14px 38px rgba(15,23,42,0.45)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 30px rgba(15,23,42,0.35)";
            }}
          >
            <span style={S.btnTitle}>👤 Interface responsable</span>
            <span style={S.btnDesc}>
              Accès complet à la gestion du planning, des gardes, des règles et
              de l&apos;équipe médicale.
            </span>
          </button>

          {/* Interface Médecin */}
          <button
            style={{ ...S.btn, ...S.btnLight }}
            onClick={() => navigate("/medecin")}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 14px 34px rgba(148,163,184,0.45)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 8px 22px rgba(148,163,184,0.35)";
            }}
          >
            <span style={S.btnTitle}>🩺 Interface médecins</span>
            <span style={S.btnDesc}>
              Consultation du planning validé, des gardes validées et saisie des
              desiderata (planning et gardes).
            </span>
          </button>
        </div>

        <div style={S.footer}>
          Interface de test – Février 2026 (planning Port Royal / gardes
          Port Royal).
        </div>
      </div>
    </div>
  );
}